module.exports = __webpack_public_path__ + "media/images/thum-d6db0825.jpg";